const _ = require('lodash');

const loadLocaleWithFallbacks = async (lang, ns, fallbackLocales) => {
  try {
    const targetLocale = await import(`./locales/${lang}/${ns}.json`).then(
      (x) => x.default
    );
    return _.defaultsDeep(targetLocale, ...fallbackLocales);
  } catch (e) {
    return fallbackLocales.length == 1
      ? fallbackLocales[0]
      : _.defaultsDeep(...fallbackLocales);
  }
};

module.exports = {
  defaultLocale: 'en',
  locales: [
    'ar',
    'da',
    'de',
    'en',
    'es',
    'es-419',
    'et',
    'fr',
    'fr-CA',
    'he',
    'it',
    'ja',
    'ko',
    'nl',
    'pl',
    'pt',
    'sr-Latn',
    'sv',
    'tr',
    'zh',
    'zh-TW',
  ],
  pages: {
    'rgx:^/internal/(courses|themes)': [
      'common',
      'nav',
      'slides',
      'concerns',
      'learning-center/assignments',
      'learning-center/common',
      'learning-center/dashboard',
      'learning-center/static',
    ],
    'rgx:^/learning*': [
      'learning-center/assignments',
      'learning-center/auth',
      'learning-center/common',
      'learning-center/dashboard',
      'learning-center/static',
      'learning-center/scorm',
      'learning-center/learning-library',
      'learning-center/policy-bot',
      'shared/auth',
      'concerns', // CTABlock
      'slides', // For legacy slides'
    ],
    'rgx:^/manager*': ['learning-center/common'],
    'rgx:^/content-library*': ['learning-center/assignments'],
    'rgx:/transcript': [
      'learning-center/assignments',
      'slides', // For legacy slides'
    ],
    '/legal-and-privacy': ['learning-center/common', 'learning-center/static'],
    // TODO (HCM): Replace with `cases` domain
    'rgx:^/hotline.*': ['concerns'],
    // TODO (HCM): Teardown
    'rgx:^/raise-a-concern.*': ['concerns'],
    '/scorm-export': ['learning-center/scorm'],
    '/reset-password': ['shared/auth'],

    // Legacy
    '*': ['modals'],
    '/training': ['common', 'nav', 'slides', 'concerns'],
    '/widgets/docebo': ['common', 'nav'],
  },
  loadLocaleFrom: async (lang, ns) => {
    const langFallbacks = {
      'fr-CA': 'fr',
    };
    const en = await import(`./locales/en/${ns}.json`).then((x) => x.default);
    if (lang === 'en') {
      return en;
    }
    if (lang in langFallbacks) {
      try {
        const fallbackLanguage = langFallbacks[lang];
        const fallbackLocale = await import(
          `./locales/${fallbackLanguage}/${ns}.json`
        ).then((x) => x.default);
        return loadLocaleWithFallbacks(lang, ns, [fallbackLocale, en]);
      } catch (e) {
        return loadLocaleWithFallbacks(lang, ns, [en]);
      }
    } else {
      return loadLocaleWithFallbacks(lang, ns, [en]);
    }
  },
  interpolation: {
    format: function (value, format) {
      if (value && format === 'bold') {
        return `<strong>${value}</strong>`;
      }
      if (value && format === 'uppercase') {
        return value.toUpperCase();
      }
      if (value && format === 'lowercase') {
        return value.toLowerCase();
      }
      if (value instanceof Date) {
        // Formatting date to browser's default language.
        // If you want to format it to the learner's nudge, change 'default' to the variable, lng
        return new Intl.DateTimeFormat('default', {
          dateStyle: format,
        }).format(value);
      }
      return value;
    },
  },
};
